import { InviteService } from './../../services/invite.service';
import { DatePipe } from '@angular/common';
import { Component,HostListener,Injectable, NgZone,OnInit,OnDestroy,} from '@angular/core';
import { Router } from '@angular/router';
import { NgbCalendar,NgbDate, NgbDateAdapter,NgbDateParserFormatter,NgbDatepickerConfig,NgbDateStruct,} from '@ng-bootstrap/ng-bootstrap';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { Subscription } from 'rxjs';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  standalone: false,
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  toDate: Date;
  selectedToDate: any;
  tDate: any;
  formattedSelectedToDate: any;
  fromDate: Date;
  fDate: any;
  selectedDate: any;
  formattedSelectedDate: any;
  searchText: string = '';
  companyList: any;
  multiSelectionCompanyName: any = [];
  selectedCompanyName: any;
  selctionlength: number;
  selectedId: any;
  historyList: any = [];
  page: any = 1;
  tempHistoryList: any = [];
  pageSize: number = 10;
  displayCount: any;
  selectedCompanyId: any;
  tempDate: any;
  formattedDate: string;
  minDate;
  maxDate;
  openOptionDrawerHistory: any[] = [];
  globalIndex1;
   minToDate
  minFromDate

  constructor(private router: Router, public datepipe: DatePipe, private appStateSrv: AppStateProvider, private zone: NgZone, private dateAdapter: NgbDateAdapter<string>, private ngbCalendar: NgbCalendar, private ngbDatepickerConfig: NgbDatepickerConfig, private dateSrv: DateService, private invSrv: InviteService, private sideNavService: SidenavService)
   {

    const current = new Date();
    let yesterday = new Date();
    const jsDate = new Date;
    yesterday. setDate(jsDate. getDate() - 90)

    this.minDate = {
      year: yesterday.getFullYear(),
      month: yesterday.getMonth()+1 ,
      day: yesterday.getDate(),
    };
    this.maxDate={
      year: current.getFullYear(),
      month: current.getMonth() +1,
      day: current.getDate()
    }

    ngbDatepickerConfig.outsideDays = 'visible';
    localStorage.setItem('expandNav', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'VMS Approval',
      subNav: '0',
      subNavLink: '/bulk-invite-approval/history',
    });
    this.appStateSrv.setSideNavState(route);


  }

  ngOnInit(): void {
    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString( new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString( new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();

    this.getCompanyList();
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');
    localStorage.removeItem('expandNavUser');
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNav');
    this.subscriptions.unsubscribe();
  }

  @HostListener('click', ['$event'])
  captureClick(event) {

    this.openOptionDrawerHistory = this.openOptionDrawerHistory.map(
      (element, i) => {
        if ( i === this.globalIndex1 &&(event.target.className === 'hc' || event.target.className.includes('hc'))) return (element = true);
         return (element = false);
      }
    );
  }

  getCompanyList() {
    const data = {
      parkId: localStorage.getItem('parkId'),
    };

    this.subscriptions.add(this.invSrv.getCompanyList(data).subscribe((res) => {
      this.companyList = res;
      this.companyList.unshift({ parkTenantName: 'All', parkTenantId: null });
      this.selectCompanyName({ parkTenantName: 'All', parkTenantId: null });
    }))
  }

  getHistoryList() {


    const data = {
      resquestStatus: [],
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      pageNo: 0,
      size: 0,
      invitationType: 'bulkInvite',
      parkTenantId: this.multiSelectionCompanyName,
      parkId:localStorage.getItem('parkId')
      // userId: 636,
    };
    const data1 = {
      resquestStatus: [],
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      pageNo: this.page,
      size: this.pageSize,
      invitationType: 'bulkInvite',
      parkTenantId: this.multiSelectionCompanyName,
      parkId:localStorage.getItem('parkId')

      // userId: 636,
    };
    this.subscriptions.add(this.invSrv.getHistoryDetail(data).subscribe((res) => {
      this.displayCount = res.list.length;
    }))
    this.subscriptions.add(this.invSrv.getHistoryDetail(data1).subscribe((res) => {
      this.historyList = res.list;
      this.tempHistoryList = this.historyList;
    }))
  }

  formatDate(date, type) {
    if (date == null) return;
    this.tempDate = date.split('T')[0].split('-');
    this.formattedDate = this.dateSrv.convertDateToLocaleString( this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    if (type == 'date') return this.tempDate[2];
    if (type == 'month') return this.formattedDate.split(' ')[1].replace(/,\s*$/, '');
    if (type == 'format') return (this.formattedDate.split(' ')[0] +' ' +this.formattedDate.split(' ')[1] +' ' +this.formattedDate.split(' ')[2]);
    if (type == 'formatDate') return this.formattedDate;
  }

  selectCompanyName(item) {

    if (item.parkTenantId !== null)
      if (this.multiSelectionCompanyName.includes(item.parkTenantId))
        this.multiSelectionCompanyName.splice(this.multiSelectionCompanyName.indexOf(item.parkTenantId), 1 );
      else this.multiSelectionCompanyName.push(item.parkTenantId);
    else this.multiSelectionCompanyName = [];

    let length = this.multiSelectionCompanyName.length - 1;
    this.selctionlength = length;
    this.selectedId = item.parkTenantId;

    if (item.parkTenantName != 'All') {
      this.selectedCompanyName = this.companyList.find((x) =>
          x.parkTenantId ==this.multiSelectionCompanyName[this.multiSelectionCompanyName.length - 1 ] )?.parkTenantName;
    } else {
      this.selectedCompanyName = item.parkTenantName;
    }
    this.getHistoryList();
  }

  public async updateSelectedDate(date: NgbDate) {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.fromDate = jsDate;
    this.fDate = this.updateDateToCalendar(date);
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(date.day,date.month - 1,date.year);
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        this.getHistoryList();
      } else {
        this.zone.run(() => {
          this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
          this.selectedToDate = this.datepipe.transform( new Date(),'MM/dd/yyyy' );
          this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(),new Date().getMonth(),new Date().getFullYear());
          this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString( new Date().getDate(), new Date().getMonth(), new Date().getFullYear() );
          this.fDate = this.updateDateToCalendar();
          this.tDate = this.updateDateToCalendar();
        });
        this.appStateSrv.showToast( 'From date should not be greater than to date' );
        await delay(2000);
        this.getHistoryList();
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =(date == undefined)? this.dateAdapter.toModel(this.ngbCalendar.getToday())!: this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  public async updateSelectedToDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.toDate = jsDate;
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString( date.day, date.month - 1, date.year);
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        this.getHistoryList();
      } else {
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        this.selectedToDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString( new Date().getDate(), new Date().getMonth(), new Date().getFullYear());
        this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(),  new Date().getMonth(),  new Date().getFullYear());
        this.fDate = this.updateDateToCalendar();
        this.tDate = this.updateDateToCalendar();
        this.appStateSrv.showToast('From date should not be greater than to date' );
        await delay(2000);
        this.getHistoryList();
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  navigateToDetail(id) {
    localStorage.setItem('navigate', '1');
    this.router.navigate(['/bulk-invite-approval/details'], { queryParams: { id: id }});
  }

  handlePageChange(event) {
    this.page = event;
    this.getHistoryList();
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }
  paginationCount(val) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }
  checkDate(date){
    if(new Date()<new Date(date)) return true;
      return false

  }
}
